import { resolveUrl } from "../../../utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

export async function bulkMarkAsRead(selectedItems: string[]) {
  const url = resolveUrl(`/notifications/bulkMarkAsRead`);

  const response = await fetch(url, {
    body: JSON.stringify(selectedItems),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  return await response.json();
}
